import { render, staticRenderFns } from "./EmailBroadcastEditorPage.vue?vue&type=template&id=8923c86a&scoped=true"
import script from "./EmailBroadcastEditorPage.vue?vue&type=script&lang=js"
export * from "./EmailBroadcastEditorPage.vue?vue&type=script&lang=js"
import style0 from "./EmailBroadcastEditorPage.vue?vue&type=style&index=0&id=8923c86a&prod&lang=scss&scoped=true"
import style1 from "./EmailBroadcastEditorPage.vue?vue&type=style&index=1&id=8923c86a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8923c86a",
  null
  
)

export default component.exports